import PropTypes from "prop-types";
import "./EmptyState.css";

/**
 * Generic empty-state component.
 * Renders a centred message with an optional icon and action button.
 */
export default function EmptyState({ icon, title, message, action }) {
  return (
    <div className="empty-state" role="status" aria-live="polite">
      {icon && (
        <div className="empty-state-icon" aria-hidden="true">
          {icon}
        </div>
      )}
      <p className="empty-state-title">{title}</p>
      {message && <p className="empty-state-msg">{message}</p>}
      {action && (
        <button className="btn-gold" onClick={action.onClick}>
          <span>{action.label}</span>
        </button>
      )}
    </div>
  );
}

EmptyState.propTypes = {
  /** Optional emoji or SVG element shown above the title */
  icon: PropTypes.node,
  /** Primary message (required) */
  title: PropTypes.string.isRequired,
  /** Secondary descriptive text */
  message: PropTypes.string,
  /** Optional CTA button */
  action: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }),
};

EmptyState.defaultProps = {
  icon: null,
  message: null,
  action: null,
};
